<ng-container *ngIf="!somenteVisualizar">
  <div class="row">
    <div class="col d-flex justify-content-end">
      <button nz-button type="button" nzType="primary" [nzSize]="'large'" class="rounded-pill" (click)="novo()">
        Adicionar Vínculo
      </button>
    </div>
  </div>
</ng-container>

<nz-divider class="m-0 p-0 mt-4"></nz-divider>

<div class="d-flex flex-column page-content border border-radius w-100" id="vinculoTabela">
  <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
    [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate"
    [nzScroll]="{ x: 'max-content'}">
    <thead>
      <tr>
        <ng-container *ngIf="!entidade">
          <th class="sortable-header" nzColumnKey="nomeEntidade" nzWidth="250px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
            [nzSortOrder]="sortOrderOf('nomeEntidade')"
            (mousedown)="rememberShift($event, 'nomeEntidade')"
            (nzSortOrderChange)="onColumnSort('nomeEntidade', $event)"
            nz-tooltip
            nzTooltipTitle="Shift + clique para ordenar por mais de uma coluna">
            Entidade
            <span class="sort-priority" *ngIf="sortPriorityOf('nomeEntidade') as prioridade">{{ prioridade }}</span>
          </th>
        </ng-container>

        <th class="sortable-header" nzColumnKey="principal" nzWidth="100px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
          [nzSortOrder]="sortOrderOf('principal')"
          (mousedown)="rememberShift($event, 'principal')"
          (nzSortOrderChange)="onColumnSort('principal', $event)">
          Principal
          <span class="sort-priority" *ngIf="sortPriorityOf('principal') as prioridade">{{ prioridade }}</span>
        </th>

        <ng-container *ngIf="!pessoa">
          <th class="sortable-header" nzColumnKey="nomePessoa" nzWidth="250px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
            [nzSortOrder]="sortOrderOf('nomePessoa')"
            (mousedown)="rememberShift($event, 'nomePessoa')"
            (nzSortOrderChange)="onColumnSort('nomePessoa', $event)">
            Pessoa
            <span class="sort-priority" *ngIf="sortPriorityOf('nomePessoa') as prioridade">{{ prioridade }}</span>
          </th>
        </ng-container>
        <th class="sortable-header" nzColumnKey="nomeCargo" nzWidth="250px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
          [nzSortOrder]="sortOrderOf('nomeCargo')"
          (mousedown)="rememberShift($event, 'nomeCargo')"
          (nzSortOrderChange)="onColumnSort('nomeCargo', $event)">
          Cargo
          <span class="sort-priority" *ngIf="sortPriorityOf('nomeCargo') as prioridade">{{ prioridade }}</span>
        </th>
        <th class="sortable-header" nzColumnKey="cargoReferencia" nzWidth="250px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
          [nzSortOrder]="sortOrderOf('cargoReferencia')"
          (mousedown)="rememberShift($event, 'cargoReferencia')"
          (nzSortOrderChange)="onColumnSort('cargoReferencia', $event)">
          Cargo Referência
          <span class="sort-priority" *ngIf="sortPriorityOf('cargoReferencia') as prioridade">{{ prioridade }}</span>
        </th>

        <th class="sortable-header" nzColumnKey="entidadeRepresentada" nzWidth="250px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
          [nzSortOrder]="sortOrderOf('entidadeRepresentada')"
          (mousedown)="rememberShift($event, 'entidadeRepresentada')"
          (nzSortOrderChange)="onColumnSort('entidadeRepresentada', $event)">
          Entidade Representada
          <span class="sort-priority" *ngIf="sortPriorityOf('entidadeRepresentada') as prioridade">{{ prioridade }}</span>
        </th>
        <th class="sortable-header" nzColumnKey="cargoRepresentado" nzWidth="250px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
          [nzSortOrder]="sortOrderOf('cargoRepresentado')"
          (mousedown)="rememberShift($event, 'cargoRepresentado')"
          (nzSortOrderChange)="onColumnSort('cargoRepresentado', $event)">
          Cargo Ent. Representado
          <span class="sort-priority" *ngIf="sortPriorityOf('cargoRepresentado') as prioridade">{{ prioridade }}</span>
        </th>
        <th class="sortable-header" nzColumnKey="tipoVinculo" nzWidth="110px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
          [nzSortOrder]="sortOrderOf('tipoVinculo')"
          (mousedown)="rememberShift($event, 'tipoVinculo')"
          (nzSortOrderChange)="onColumnSort('tipoVinculo', $event)">
          Tipo Vínculo
          <span class="sort-priority" *ngIf="sortPriorityOf('tipoVinculo') as prioridade">{{ prioridade }}</span>
        </th>
        <th class="sortable-header" nzColumnKey="inicioVinculo" nzWidth="110px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
          [nzSortOrder]="sortOrderOf('inicioVinculo')"
          (mousedown)="rememberShift($event, 'inicioVinculo')"
          (nzSortOrderChange)="onColumnSort('inicioVinculo', $event)">
          Início Vinculo
          <span class="sort-priority" *ngIf="sortPriorityOf('inicioVinculo') as prioridade">{{ prioridade }}</span>
        </th>
        <th class="sortable-header" nzColumnKey="ultimaAlteracao" nzWidth="110px" nzShowSort [nzSortFn]="true" [nzSortPriority]="true"
          [nzSortOrder]="sortOrderOf('ultimaAlteracao')"
          (mousedown)="rememberShift($event, 'ultimaAlteracao')"
          (nzSortOrderChange)="onColumnSort('ultimaAlteracao', $event)">
          Última Alteração
          <span class="sort-priority" *ngIf="sortPriorityOf('ultimaAlteracao') as prioridade">{{ prioridade }}</span>
        </th>

        <ng-container *ngIf="!somenteVisualizar">
          <th class="text-center" nzWidth="80px" [nzRight]="true">Ações</th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of dataSet">
        <ng-container *ngIf="!entidade">
          <td>{{ item?.nomeEntidade }}</td>
        </ng-container>

        <td>{{ item?.principal ? 'Sim' : 'Não' }}</td>

        <ng-container *ngIf="!pessoa">
          <td>{{ item?.nomePessoa }}</td>
        </ng-container>
        <td>{{ item?.nomeCargo }}</td>
        <td>{{ item?.cargoReferencia }}</td>
        <td>{{ item?.entidadeRepresentada }}</td>
        <td>{{ item?.cargoEntidadeRepresentada }}</td>
        <td>{{ item?.tipoVinculo }}</td>
        <td>{{ item?.inicioVinculo }}</td>
        <td>{{ item?.dataUltimaAtualizacao }}</td>
        <ng-container *ngIf="!somenteVisualizar">
          <td class="text-center" [nzRight]="true">
            <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
              <span nz-icon nzType="more" nzTheme="outline"></span>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item type="button" (click)="editar(item)">
                  <a>Editar/Consultar</a>
                </li>

                <ng-container *ngIf="!entidade">
                  <li nz-menu-item type="button" (click)="goToEntidade(item.idEntidade)">
                    <a>Ir para Entidade</a>
                  </li>
                </ng-container>

                <ng-container *ngIf="!pessoa">
                <li nz-menu-item type="button" (click)="goToPessoa(item.idPessoa)">
                  <a>Ir para Pessoa</a>
                </li>
              </ng-container>

              </ul>
            </nz-dropdown-menu>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </nz-table>
  <ng-template #footerTemplate>
    <section class="d-flex justify-content-end w-100">
      <app-pagination [itemPorPagina]="10"></app-pagination>
    </section>
  </ng-template>
  <ng-template #semDadosTemplate>
    <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
      <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
    </div>
  </ng-template>
</div>
